<script setup>
import { useConfiguratorStore } from '../../stores/configurator';
import Loader from '../Loader.vue';

const configurationStore = useConfiguratorStore();

</script>

<template>
    <div
        class="tw-size-full tw-absolute tw-left-0 tw-top-0 tw-z-10 tw-pointer-events-none tw-transition-opacity tw-ease-in-out tw-duration-500"
        :class="configurationStore.isImageLoading ? 'tw-opacity-100' : 'tw-opacity-0'"
    >
        <Loader class="tw-scale-100 tw-text-white tw-absolute tw--translate-x-1/2 tw--translate-y-1/2 tw-top-1/2 tw-left-1/2 tw-z-30" />
    </div>

    <div class="tw-absolute tw-size-full tw-left-0 tw-top-0 tw-z-0 tw-pointer-events-none tw-bg-white">
        <img
            :src="configurationStore.imageSet.hinge.desktop"
            class="layers tw-absolute tw-object-cover tw-size-full tw-left-0 tw-top-0 tw-z-30"
        >
        <img
            :src="configurationStore.imageSet.handle.desktop"
            class="layers tw-absolute tw-object-cover tw-size-full tw-left-0 tw-top-0 tw-z-20"
        >
        <img
            :src="configurationStore.imageSet.door.desktop"
            class="layers tw-absolute tw-object-cover tw-size-full tw-left-0 tw-top-0 tw-z-0 tw-bg-black"
        >
        <img
            :src="configurationStore.imageSet.stage.desktop"
            class="layers tw-absolute tw-object-cover tw-size-full tw-left-0 tw-top-0 tw-z-[5]"
        >
    </div>
</template>